<template>
    <div class="page-table mainDiv" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">
            Ürün Opsiyon İşlemleri
        </div>
        <el-row :gutter="10">
            <el-col :lg="18" :md="18" :sm="24" :xs="24">
                <div class="page-header card-base card-shadow--medium animated fadeInUp">
                    <div class="padding-bottom-10">
                        <el-radio-group size="small" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9"
                                        text-color="gray">
                            <el-radio-button label="1">
                                <i class="mdi mdi-circle-edit-outline mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                                <transition
                                        name="slide-fade"><label v-if="selectIcon==='1'">Aktif Ürün Opsiyon</label>
                                </transition>
                            </el-radio-button>
                            <el-radio-button label="0">
                                <i class="mdi mdi-circle-edit-outline  mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                                <transition
                                        name="slide-fade"><label v-if="selectIcon==='0'">Pasif Ürün Opsiyon</label>
                                </transition>
                            </el-radio-button>
                        </el-radio-group>
                    </div>
                    <el-table
                            :data="urunOpsiyonFormListesi"
                            style="width: 100%">
                        <el-table-column
                                label="Sıra"
                                type="index"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="baslik"
                                label="Ürün Adı"
                                width="auto">
                        </el-table-column>
                        <el-table-column
                                label="İşlem"
                                align="right"
                                width="auto">
                            <template slot-scope="scope">
                                <el-tooltip :content='$t("src.views.apps.haberler.kategori.liste.duzenle")'
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-on:click="selectionIndex=scope.$index; selection=scope.row; updateStart(scope.row); "
                                            type="text"
                                            class="buttonEdit"
                                            icon="el-icon-edit">
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip :content='$t("src.views.apps.firma.yonetici.liste.yoneticiaktif")'
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-if="selectIcon==='0'"
                                            @click="durumChange(scope.row,scope.$index,urunOpsiyonFormListesi,1)"
                                            type="text"
                                            icon="mdi mdi-play mdi-24px">
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip :content='$t("src.views.apps.haberler.kategori.liste.sil")'
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-if="selectIcon==='1'"
                                            v-on:click="dialogVisible = true; selection=scope.row; selectionIndex=scope.$index"
                                            type="text"
                                            class="buttonDel"
                                            icon="mdi mdi-delete mdi-24px">
                                    </el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                            background
                            layout="sizes,prev, pager, next, jumper, total"
                            :total="total"
                            @size-change="handleSizeChange"
                            @current-change="pageChange"
                            :page-sizes="[10, 20, 50, 100]"
                            :current-page.sync="page"
                            :next-click.sync="page"
                            :prev-click.sync="page"
                            @next-click="pageChange"
                            @prev-click="pageChange">
                    </el-pagination>
                </div>

            </el-col>
            <el-col :lg="6" :md="6" :sm="24" :xs="24">
                <el-form status-icon label-position="top" :model="urunOpsiyonForm" :rules="rulesAracUrun" ref="urunOpsiyonForm" @submit.native.prevent="enter"
                         class="demo-ruleForm">
                    <div class="card-base card-shadow--medium demo-box bg-white animated fadeInUp">
                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='Başlık :'
                                              prop="baslik">
                                    <el-input size="small"
                                              v-model="urunOpsiyonForm.baslik"
                                              placeholder='Başlık Giriniz'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='Başlık (Almanca) :'
                                              prop="baslikDE">
                                    <el-input size="small"
                                              v-model="urunOpsiyonForm.baslikDE"
                                              placeholder='Başlık Giriniz'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item label="Yapışkan :" prop="yapiskan">
                                    <el-switch
                                            v-model="urunOpsiyonForm.yapiskan"
                                            active-value="1"
                                            inactive-value="0"
                                            active-text="Sabitle"
                                            inactive-text="Sabitleme">
                                    </el-switch>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row class="col-p">
                            <el-form-item>
                                <el-button v-if="btnVisible" size="small" v-on:click="urunOpsiyonFormTanimlama('urunOpsiyonForm')"
                                           type="primary">
                                    Tanımla
                                </el-button>
                                <el-button v-else size="small" v-on:click="guncelleme('urunOpsiyonForm')" type="primary">
                                    Güncelle
                                </el-button>
                                <el-button v-if="!btnVisible" size="small" v-on:click="vazgec('urunOpsiyonForm')">
                                    Vazgeç
                                </el-button>
                            </el-form-item>
                        </el-row>
                    </div>


                    <el-collapse v-model="activeCollapse" class="yanForm animated fadeInUp margin-top-10">
                        <el-collapse-item class="card-shadow--medium"
                                          title='Kategori' name="2">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label="Kategori :" prop="kategoriList">
                                        <el-tree
                                                class="baskaTree"
                                                :data="treeList"
                                                @check="handleNodeClick"
                                                :default-checked-keys="checkedKeysKategori"
                                                check-strictly
                                                node-key="id"
                                                ref="tree"
                                                icon-class
                                                show-checkbox
                                                :props="defaultProps">
                                        </el-tree>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item class="card-shadow--medium"
                                          title='Konum' name="3">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label="Konum : " prop="konum">
                                        <el-button type="primary" size="mini" @click="dialogKonum = true">
                                            {{this.konumText}}
                                        </el-button>
                                        &nbsp;
                                        <img v-if="urunOpsiyonForm.konum === '0'" style="float: right"
                                             src="../../../../assets/images/13.png" width="40%" height="40%">
                                        <img v-if="urunOpsiyonForm.konum === '1'" style="float: right"
                                             src="../../../../assets/images/14.png" width="40%" height="40%">
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                    </el-collapse>
                </el-form>
            </el-col>
        </el-row>
        <el-dialog
                :title='$t("src.views.apps.haberler.liste.uyari")'
                :visible.sync="dialogVisible"
                width="30%"
                center>
            <span>"{{selection["baslik"]}}" opsiyonunu silmek istediğinize emin misiniz?</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="durumChange(selection,selectionIndex,urunOpsiyonFormListesi,0), dialogVisible = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="dialogVisible = false"></el-button>
                </span>
        </el-dialog>
        <el-dialog
                title="Opsiyon Konumu"
                :visible.sync="dialogKonum"
                width="50%">
            <el-row>
                <el-col :span="12">
                    <el-radio v-model="urunOpsiyonForm.konum" label="0" @change="changeKonum('0')">
                        <img src="../../../../assets/images/13.png" alt="Alt" width="80%" height="80%">
                    </el-radio>
                </el-col>
                <el-col :span="12">
                    <el-radio v-model="urunOpsiyonForm.konum" label="1" @change="changeKonum('1')">
                        <img src="../../../../assets/images/14.png" alt="Sağ" width="80%" height="80%">
                    </el-radio>
                </el-col>
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
    import urunService from '../../../../WSProvider/UrunService'
    import notification from '../../../../notification'
    import JQuery from 'jquery';

    let $ = JQuery;
    let base64 = require('base64_js');
    let userDataSortas = "";
    export default {
        name: "OpsiyonIslem",
        mounted() {
            // this.markaCount();
            this.getOpsiyonListesi();
            this.getTreeList();
        },
        data() {
            return {
                dialogKonum: false,
                konumText: "Seç",
                kategoriListesi: [],
                page: 0,
                sizes: 10,
                postPage: 0,
                total: null,
                selectIcon: '1',
                radio: '1',
                activeCollapse: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                urunOpsiyonFormListesi: [],
                updateKodu: '',
                btnVisible: true,
                selection: '',
                selectionIndex: '',
                dialogVisible: false,
                duzenleBtnVisible: true,
                VisibleA: false,
                linkVisible: false,
                linkChange: true,
                disabled: false,
                treeList: [],
                updateData: [],
                updateDataKat: [],
                urunOpsiyonFormKlon: {},
                defaultProps: {
                    id: 'id',
                    children: 'children',
                    label: 'name'
                },
                checkedKeysKategori: [],
                oldKategoriList: [],

                urunOpsiyonForm: {
                    baslik: "",
                    baslikDE: "",
                    kategoriList: [],
                    yapiskan: '0',
                    durum: "1",
                    konum: "1",
                },
                rulesAracUrun: {
                    baslik: [{
                        required: true,
                        message: "Lütfen Urun Giriniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            getTreeList() {
                urunService.kategoriTree().then((response) => {
                    if (response.status === 200) {
                        this.treeList = response.data;
                    } else {
                        notification.Status(response.status, this);
                    }
                })
            },
            handleNodeClick(data, checked, indeterminate) {
                let self = this;
                this.urunOpsiyonForm.kategoriList = [];
                Object.values(checked.checkedNodes).forEach(function (e) {
                    self.urunOpsiyonForm.kategoriList.push(e.id);
                })
                Object.values(checked.halfCheckedNodes).forEach(function (e) {
                    self.urunOpsiyonForm.kategoriList.push(e.id);
                })
            },
            handleSizeChange(val) {
                this.sizes = val;
                this.getOpsiyonListesi();
            },
            handleChange(event) {
                this.selectIcon = event;
                // this.markaCount();
                this.getOpsiyonListesi();
            },
            markaCount() {
                urunService.markaCount(this.selectIcon).then((response) => {
                    if (response.status === 200) {
                        this.total = parseInt(response.data);
                    }
                });
            },
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getOpsiyonListesi();
            },
            getOpsiyonListesi() {
                urunService.uopsiyonList(this.selectIcon, this.postPage, this.sizes).then((response) => {
                    if (response.status === 200) {
                        this.urunOpsiyonFormListesi = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            updateStart(scope) {
                let self = this;
                this.urunOpsiyonForm.baslik = scope.baslik;
                this.urunOpsiyonForm.baslikDE = scope.dil.de.baslik;
                this.urunOpsiyonForm.konum = scope.konum;
                this.urunOpsiyonForm.yapiskan = scope.yapiskan;
                this.urunOpsiyonFormKlon.baslik = scope.baslik;
                this.urunOpsiyonFormKlon.konum = scope.konum;
                this.urunOpsiyonFormKlon.yapiskan = scope.yapiskan;
                this.urunOpsiyonFormKlon.baslikDE = scope.dil.de.baslik;
                this.oldKategoriList = scope.kategori;
                if (scope.kategori) {
                    self.checkedKeysKategori = []
                    self.urunOpsiyonForm.kategoriList = []
                    scope.kategori.forEach(function (e) {
                        self.urunOpsiyonForm.kategoriList.push(e.ukategoriId)
                        self.checkedKeysKategori.push(e.ukategoriId)
                    })
                    this.$nextTick(() => {
                        this.$refs.tree.setCheckedKeys(self.checkedKeysKategori);
                    });
                }
                this.updateKodu = scope.uopsiyonId;
                this.btnVisible = false;
            },
            vazgec(formName) {
                this.$refs[formName].resetFields();
                this.btnVisible = true;
            },
            enter() {
                if (this.btnVisible) {
                    this.urunOpsiyonFormTanimlama('urunOpsiyonForm');
                } else this.guncelleme('urunOpsiyonForm')
            },
            urunOpsiyonFormTanimlama(formName) {
                let dil = [];
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        dil = {
                            de: this.urunOpsiyonForm.baslikDE
                        };
                        urunService.uopsiyonTanimlama(this.urunOpsiyonForm.baslik, this.urunOpsiyonForm.yapiskan, this.urunOpsiyonForm.konum, this.urunOpsiyonForm.durum, dil, this.urunOpsiyonForm.kategoriList).then((response) => {
                            if (response.status === 200) {
                                this.urunOpsiyonFormListesi.push(response.data);
                                notification.Status('success', this, 'Ürün opsiyon başarıyla eklendi.');
                                this.urunOpsiyonForm.kategoriList = [];
                                this.$refs[formName].resetFields();
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir ürün opsiyon zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            // guncelleme(formName) {
            //     this.$refs[formName].validate((valid) => {
            //         if (valid) {
            //             urunService.uopsiyonGuncelle(this.updateKodu, this.urunOpsiyonForm.baslik).then((response) => {
            //                 if (response.status === 200) {
            //                     this.urunOpsiyonFormListesi.splice(this.selectionIndex, 1);
            //                     this.urunOpsiyonFormListesi.splice(this.selectionIndex, 0, {
            //                         baslik: response.data.baslik,
            //                         uopsiyonId: response.data.uopsiyonId
            //                     });
            //                     notification.Status('success', this, 'Ürün başarıyla güncellendi...');
            //                     this.$refs[formName].resetFields();
            //                     this.btnVisible = true;
            //                 } else if (response.status === 200) {
            //                     notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir ürün zaten mevcut');
            //                 } else {
            //                     notification.Status(response.status, this)
            //                 }
            //             });
            //         }
            //     })
            // },
            guncelleme(formName) {
                let self = this;
                var dizi = [];
                for (var key in this.urunOpsiyonFormKlon) {
                    if (key !== 'baslikDE') {
                        if (this.urunOpsiyonFormKlon[key] !== this.urunOpsiyonForm[key]) {
                            if (this.urunOpsiyonForm[key] || this.urunOpsiyonForm[key] === '') {
                                var item = {
                                    type: key,
                                    value: this.urunOpsiyonForm[key]
                                };
                                dizi.push(item);
                            }
                        }
                    }
                    if (key === 'baslikDE') {

                        if (this.urunOpsiyonFormKlon.baslikDE !== this.urunOpsiyonForm.baslikDE) {
                            if (this.urunOpsiyonForm.baslikDE || this.urunOpsiyonForm.baslikDE === '') {
                                dizi.push({
                                    type: "dil",
                                    value: {
                                        de: this.urunOpsiyonForm.baslikDE
                                    }
                                })
                            }
                        }

                    }
                }
                for (var ii = 0; ii < self.urunOpsiyonForm.kategoriList.length; ii++) {
                    let obj11 = self.oldKategoriList.find(data => data.ukategoriId === self.urunOpsiyonForm.kategoriList[ii]);
                    if (obj11 === undefined) {
                        self.updateDataKat.push({
                            durum: 1,
                            ukategoriId: self.urunOpsiyonForm.kategoriList[ii],
                        });
                    }
                }
                for (var jj = 0; jj < this.oldKategoriList.length; jj++) {
                    let obj00 = self.urunOpsiyonForm.kategoriList.find(data => data === self.oldKategoriList[jj].ukategoriId);
                    if (obj00 === undefined) {
                        self.updateDataKat.push({
                            durum: 0,
                            ukategoriId: self.oldKategoriList[jj].ukategoriId,
                        })
                    }
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (dizi.length !== 0) {
                            urunService.uopsiyonGuncelle(this.updateKodu, dizi).then((response) => {
                                if (response.status === 200) {
                                    this.urunOpsiyonFormListesi.splice(this.selectionIndex, 1);
                                    this.urunOpsiyonFormListesi.splice(this.selectionIndex, 0, {
                                        baslik: response.data.baslik,
                                        konum: response.data.konum,
                                        yapiskan: response.data.yapiskan,
                                        kategori: response.data.kategori,
                                        uopsiyonId: response.data.uopsiyonId
                                    });
                                    notification.Status('success', this, 'Opsiyon başarıyla güncellendi...');
                                    this.$refs[formName].resetFields();
                                    this.btnVisible = true;
                                    this.getOpsiyonListesi()
                                } else if (response.status === 200) {
                                    notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir opsiyon zaten mevcut');
                                } else {
                                    notification.Status(response.status, this)
                                }
                            });
                        }
                        if (self.updateDataKat.length !== 0) {
                            urunService.urunOpsiyonKategoriGuncelle(this.updateKodu, this.updateDataKat).then((response) => {
                                if (response.status === 200) {
                                    notification.Status('success', self, 'Kategori başarıyla güncellendi.');
                                    this.urunOpsiyonFormListesi.splice(this.selectionIndex, 1);
                                    this.urunOpsiyonFormListesi.splice(this.selectionIndex, 0, {
                                        baslik: response.data.baslik,
                                        kategori: response.data.kategori,
                                        uopsiyonId: response.data.uopsiyonId
                                    });
                                    this.$refs[formName].resetFields();
                                    this.btnVisible = true;
                                    this.getOpsiyonListesi()
                                } else {
                                    notification.Status(response.status, self);
                                }
                            })
                        }
                        if (self.updateDataKat.length === 0 && dizi.length === 0) {
                            notification.Status('warning', this, 'Herhangi bir değişiklik yapılmadı');
                        }
                    }
                })
            },
            durumChange(selection, index, list, durum) {
                urunService.uopsiyonDurumGuncelle(selection.uopsiyonId, durum).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Ürün durumu başarıyla değiştirildi.');
                        list.splice(index, 1);
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            changeKonum(konum) {
                this.dialogKonum = false;
                this.konumText = "Değiştir";
                switch (konum) {
                    case '0' :
                        notification.Status('success', this, 'Opsiyon konumu "Tab" olarak seçildi.');
                        break;
                    case '1' :
                        notification.Status('success', this, 'Opsiyon konumu "Sağ" olarak seçildi.');
                        break;
                }

            }
        }
    }

</script>


<style scoped>
    .el-pagination {
        margin-top: 20px;
        float: right;
    }

</style>